/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:da07a480-2b49-4cff-aa24-06148871bb52",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_vilv2LvwU",
    "aws_user_pools_web_client_id": "6g7p5mp970gbs3dsfujmg6q2c5",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "yocannaproduction-userfiles-mobilehub-614740696",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
